<template>
  <v-card>
    <v-card-title>
      <h2 style="text-align: center; font-size: 1rem">Pilih Tahun Laporan</h2>
    </v-card-title>
    <v-container>
      <v-row>
        <v-col cols="6">
          <InputCoaWithoutChild
            :itemText="itemTextFn"
            itemValue="kode"
            label="Dari Kode Perkiraan"
            v-model="subBukuBesar.from"
          />
        </v-col>
        <v-col cols="6">
          <InputCoaWithoutChild
            :itemText="itemTextFn"
            itemValue="kode"
            label="Sampai Kode Perkiraan"
            v-model="subBukuBesar.to"
          />
        </v-col>
        <v-col cols="12">
          <v-text-field
            minlength="4"
            maxlength="4"
            dense
            v-model="periode"
            type="number"
            label="YEAR"
            required
          />
        </v-col>
      </v-row>
    </v-container>

    <v-card-actions style="margin-top: 2rem">
      <v-spacer />
      <v-btn color="error" variant="text" @click="onclose"> Batal </v-btn>
      <v-btn
        color="primary"
        variant="text"
        @click="
          () => {
            onclose();
            generateSubBukuBesarYear();
          }
        "
      >
        Generate Laporan
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from '@/libs/axios';
import InputCoaWithoutChild from './InputCoaWithoutChild.vue';
export default {
  name: 'ModalContentSubBukuBesarTahun',
  components: {
    InputCoaWithoutChild,
  },
  data() {
    return {
      kodePerkiraanSelect: [],
      periode: '',
      subBukuBesar: {
        from: '',
        to: '',
      },
    };
  },
  props: {
    onclose: {
      type: Function,
      default: () => {},
    },
  },
  mounted() {
    let period = this.$getSelectedMonthYear();
    this.periode = period.dateTime;

    this.loadKodePerkiraanItem();
  },
  methods: {
    async loadKodePerkiraanItem() {
      try {
        let datas = await axios.get('/kodePerkiraanItem');

        for (const element of datas.data.data) {
          this.kodePerkiraanSelect.push({
            text: `${element.kode} - ${element.uraian}`,
            value: element.kode,
          });
        }
      } catch (err) {
        this.$toast.error(err);
      }
    },
    generateSubBukuBesarYear() {
      if (this.subBukuBesar.from == '' || this.subBukuBesar.to == '') {
        this.$toast.error('Silakan isi kode perkiraan terlebih dahulu');
        return;
      }
      this.$router.push(
        `/laporan/gl/subBukuBesar?year=1&periode=${this.periode}-01-01&from=${this.subBukuBesar.from}&to=${this.subBukuBesar.to}`
      );
    },
    itemTextFn(item) {
      return `${item.kode} - ${item.nama}`;
    },
  },
};
</script>
